/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SurveyUnitsOfMeasure from './survey-units-of-measure';
import SurveyUnitsOfMeasureDetail from './survey-units-of-measure-detail';
import SurveyUnitsOfMeasureUpdate from './survey-units-of-measure-update';
import SurveyUnitsOfMeasureDeleteDialog from './survey-units-of-measure-delete-dialog';

const SurveyUnitsOfMeasureRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SurveyUnitsOfMeasure />} />
    <Route path="new" element={<SurveyUnitsOfMeasureUpdate />} />
    <Route path=":id">
      <Route index element={<SurveyUnitsOfMeasureDetail />} />
      <Route path="edit" element={<SurveyUnitsOfMeasureUpdate />} />
      <Route path="delete" element={<SurveyUnitsOfMeasureDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SurveyUnitsOfMeasureRoutes;
